export const LOGIN_ROUTE = '/app/login'
export const LOGIN_DOMINICANA_ROUTE = '/elquebuscagana'
export const CREATE_PROFILE_ROUTE = '/app/create-profile'
export const VERIFY_NUMBER_ROUTE = '/verify-code'
export const CONTACTS_ROUTE = '/app/contacts'
export const MARKETPLACE_ROUTE = '/app/marketplace'
export const VOUCHERS_ROUTE = '/app/vouchers'
export const PARTNER_ROUTE = '/app/partner'
export const CHECKOUT_ROUTE = '/app/checkout'
export const SELECTED_VOUCHER_ROUTE = '/app/selected-voucher'
export const VALE_SENT_ROUTE = '/app/vale-sent'
export const HISTORY_ROUTE = '/app/history'
export const HELP_ROUTE = '/app/help'
export const LANDING_ROUTE = '/japon'
export const PROMOTIONS_ROUTE = '/app/promotions'
export const VOUCHE_NEW_ROUTE = '/app/voucher-new'

export const PARTNER_BY_CATEGORY_ROUTE = '/app/partners-category'
